/**
 * @generated SignedSource<<21b7c37f5ef8f15a9c4fcca80976ffa3>>
 * @relayHash 40e1a919a66c4fe67bb1e050122d3b55
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a55e95d051b2167ecc36685e46d4c5694cd263459aca86891cd6f14e38a0181f

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forgeExtensionRenderingContext"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "uiModificationsContext"
    }],
    v1 = {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    v2 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v3 = {
      "kind": "ScalarField",
      "name": "type"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "rootUiModificationsQuery",
      "selections": [{
        "args": [v1 /*: any*/, {
          "kind": "Variable",
          "name": "forgeExtensionRenderingContext",
          "variableName": "forgeExtensionRenderingContext"
        }, {
          "kind": "Variable",
          "name": "uiModificationsContext",
          "variableName": "uiModificationsContext"
        }],
        "kind": "FragmentSpread",
        "name": "fragment_AtlassianUiModificationsCore_RootFragment"
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "rootUiModificationsQuery",
      "selections": [{
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [{
          "args": [{
            "kind": "Variable",
            "name": "context",
            "variableName": "uiModificationsContext"
          }],
          "concreteType": "JiraAppUiModifications",
          "kind": "LinkedField",
          "name": "uiModifications",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "name": "appEnvId"
          }, {
            "concreteType": "JiraUiModification",
            "kind": "LinkedField",
            "name": "uiModifications",
            "plural": true,
            "selections": [v2 /*: any*/, {
              "kind": "ScalarField",
              "name": "data"
            }]
          }]
        }, {
          "concreteType": "JiraForgeQuery",
          "kind": "LinkedField",
          "name": "forge",
          "plural": false,
          "selections": [{
            "alias": "uiModificationsModules",
            "args": [v1 /*: any*/, {
              "kind": "Variable",
              "name": "context",
              "variableName": "forgeExtensionRenderingContext"
            }, {
              "kind": "Literal",
              "name": "types",
              "value": ["jira:uiModifications"]
            }],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [v2 /*: any*/, {
              "kind": "ScalarField",
              "name": "appVersion"
            }, {
              "kind": "ScalarField",
              "name": "installationId"
            }, {
              "kind": "ScalarField",
              "name": "environmentId"
            }, {
              "kind": "ScalarField",
              "name": "environmentType"
            }, {
              "kind": "ScalarField",
              "name": "environmentKey"
            }, {
              "concreteType": "JiraForgeExtensionLicense",
              "kind": "LinkedField",
              "name": "license",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "active"
              }, v3 /*: any*/, {
                "kind": "ScalarField",
                "name": "supportEntitlementNumber"
              }, {
                "kind": "ScalarField",
                "name": "trialEndDate"
              }, {
                "kind": "ScalarField",
                "name": "subscriptionEndDate"
              }, {
                "kind": "ScalarField",
                "name": "isEvaluation"
              }, {
                "kind": "ScalarField",
                "name": "billingPeriod"
              }, {
                "kind": "ScalarField",
                "name": "ccpEntitlementId"
              }, {
                "kind": "ScalarField",
                "name": "ccpEntitlementSlug"
              }, {
                "kind": "ScalarField",
                "name": "capabilitySet"
              }]
            }, {
              "kind": "ScalarField",
              "name": "properties"
            }, {
              "kind": "ScalarField",
              "name": "scopes"
            }, v3 /*: any*/, {
              "kind": "ScalarField",
              "name": "__typename"
            }, {
              "concreteType": "JiraForgeAppEgressDeclaration",
              "kind": "LinkedField",
              "name": "egress",
              "plural": true,
              "selections": [v3 /*: any*/, {
                "kind": "ScalarField",
                "name": "addresses"
              }]
            }, {
              "kind": "ScalarField",
              "name": "consentUrl"
            }]
          }]
        }]
      }]
    },
    "params": {
      "id": "a55e95d051b2167ecc36685e46d4c5694cd263459aca86891cd6f14e38a0181f",
      "metadata": {},
      "name": "rootUiModificationsQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "9036ea3b10c5003976e51018f89bdc35";
export default node;